// extracted by mini-css-extract-plugin
export default {"button":"Mn-z","reviewSort":"Nn-z"};